<script>

import {mapActions} from "pinia";
import {baseLoaderStore} from "@/store/baseLoaderStore";

export default {
  name: "ProfileFollows",
  props: {
    userId: {
      type: Number
    },
  },
  computed: {
    frameUrl() {
      return `/user/${this.userId}/mydesktop?tab=follow&_f=true&showAsPage=false`
    }
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'hideBaseLoader'
    ]),
  },
  mounted() {
    document.getElementById('followsViewFrame').onload = () => {
      this.hideBaseLoader();
    };
  }
}

</script>

<template>
  <div>
    <iframe :src="frameUrl" frameborder="0" id="followsViewFrame" class="follows-view-frame"></iframe>
  </div>
</template>

<style scoped lang="scss">
.follows-view-frame {
  width: 100%;
  height: 1240px;
}
</style>